import React, { useState } from "react";
import { Card, Col, Row } from "antd";

import HeatMap from "../../../../../../shared/maps/HeatMap";
import { Tooltip } from "antd";
// Global Styles

import {
  TooltipText,
  CardTitleText,
} from "../../../../../../shared/globalStyling/styledText";
import { QuestionCircleOutlined } from "@ant-design/icons";
import LocationsDropdown from "../../../../../../shared/maps/LocationsDropdown";
import useLocationsDropdown from "../../../../../../shared/maps/hooks/useLocationsDropdown";
import MapTypes from "../../../../../../shared/maps/MapTypes";

const styles = {
  outerContainer: {
    width: "100%",
    height: "30.2em",
  },
  map: {
    position: "relative",
    height: "100%",
    width: "100%",
  },
};

const HeatMapCard = ({ latLngs, geoTargets, observationsByGeoTarget }) => {
  const [currentLocationId, setCurrentLocationId] = useLocationsDropdown("");
  const [mapTypeId, setMapTypeId] = useState("hybrid");

  return (
    <Card
      title={<CardTitleText text={"Map"} />}
      style={{ width: "100%" }}
      bodyStyle={{
        padding: 0,
        height: "30.2em",
      }}
      bordered={false}
      extra={
        <Tooltip
          placement={"topLeft"}
          arrowPointAtCenter
          overlayStyle={{ maxWidth: "500px" }}
          title={
            <TooltipText
              text={
                <>
                  <ul
                    style={{
                      listStyle: "none",
                      paddingLeft: "2px",
                    }}
                  >
                    <li>Green means counts that are 9 and below</li>
                    <li>Green with a bit of yellow are counts 9 and up</li>
                    <li>Green with red are counts 20 and above</li>
                  </ul>
                </>
              }
            ></TooltipText>
          }
        >
          <QuestionCircleOutlined />
        </Tooltip>
      }
    >
      <div style={{ margin: "12px" }}>
        <Row>
          <Col flex={2}>
            <MapTypes mapTypeId={mapTypeId} setMapTypeId={setMapTypeId} />
          </Col>
          <Col flex={3}>
            <Row justify="end">
              <LocationsDropdown
                currentLocationId={currentLocationId}
                locations={geoTargets}
                setCurrentLocationId={setCurrentLocationId}
                title={"View Location(s)"}
              />
            </Row>
          </Col>
        </Row>
      </div>

      <HeatMap
        zoom={5}
        styles={styles}
        latLngs={latLngs}
        locations={geoTargets}
        currentLocationId={currentLocationId}
        mapTypeId={mapTypeId}
        observationsByGeoTarget={observationsByGeoTarget}
      />
    </Card>
  );
};

export { HeatMapCard };
